/* eslint-disable react/no-array-index-key */
import React from 'react';
import intl from 'react-intl-universal';
import { InputNumber, message } from 'antd';

import ImageLazyload from '@/components/LazyloadImage/';
import { parseFen2Currency } from '@/utils/number';

import styles from './index.module.scss';

// 列表
function Index($$: any) {
  if (!$$.list || $$.list.length === 0)
    return (
      <div className={styles.goodList}>
        <div className={styles.empty}>
          <div>
            <i />
            <p>请添加外设~~</p>
          </div>
        </div>
      </div>
    );

  const inputTimesConfirm = (e: any, item) => {
    const val = e.target.value;
    // 正整数校验
    if (!/(^[1-9]\d*$)/.test(val)) {
      message.warn(intl.get('goods_input_error_and_retry'));
    } else {
      $$.changeRentCount(item, Number(val));
    }
  };

  // 失焦 需要重新调用预下单和详情的接口
  const inputTimesBlur = (e: any, item) => {
    const val = e.target.value;
    // 正整数校验
    if (!/(^[1-9]\d*$)/.test(val)) {
      message.warn(intl.get('goods_input_error_and_retry'));
    } else {
      $$.changeRentCountBlur(item, Number(val));
    }
  };

  return (
    <div className={styles.goodList}>
      <div className={styles.goodsItemTitle}>
        <div className={styles.first} />
        <div className={styles.secord}></div>
        <div className={styles.third}>租金单价</div>
        <div className={styles.fourth}>数量</div>
        <div className={styles.fifth}>租借次数</div>
        <div className={styles.sixth}>租金小计</div>
      </div>
      {$$.list.map((good) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div className={styles.goodsItem} key={good.id}>
            <div className={styles.lazyImg}>
              <ImageLazyload src={good.skuThumbnail} alt={good.spuName} />
            </div>
            <div className={styles.goodName}>
              <div className={styles.spuName}>{good.spuName || '--'}</div>
            </div>
            <div className={styles.price}>{parseFen2Currency(good.goodsPrice || 0)}</div>
            <div className={styles.number}>× {good.goodsCount || 0}</div>
            <div className={styles.times}>
              <InputNumber
                value={good.goodsTimeCount}
                className={styles.inputNumber}
                min={1}
                max={999}
                onStep={(val, info) => {
                  if (info.type === 'down') {
                    $$.changeRentCount(good, Number(good.goodsTimeCount) - 1);
                    return;
                  }
                  if (info.type === 'up') {
                    $$.changeRentCount(good, Number(good.goodsTimeCount) + 1);
                    return;
                  }
                  inputTimesConfirm(val, good.goodsTimeCount + 1);
                }}
                onPressEnter={(e) => inputTimesConfirm(e, good)}
                onBlur={(e) => inputTimesBlur(e, good)}
              />
            </div>
            <div className={styles.amount}>
              {good.goodsTotalPrice !== good.actualTotalPrice && (
                <span className={styles.oldPrice}>
                  {parseFen2Currency(good.goodsTotalPrice || 0)}
                </span>
              )}
              <span className={styles.newPrice}>
                {parseFen2Currency(good.actualTotalPrice || 0)}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Index;
